<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let bgcolor = 'blue';
  export let color = 'white';
</script>
<span style="--bgcolor:{bgcolor};
--color:{color}"
      class="button" on:click={()=>dispatch('clicked')}><slot/></span>

<style>
    .button {
        display: inline-block;
        padding: 5px 10px;
        border-radius: 5px;
        background-color: var(--bgcolor);
        color: var(--color);
        cursor: pointer;
    }
</style>
